<template>
    <modal-centered-base
    :title="t('modals.multipleDownloads.title')"
    :rightButtonText="t('modals.multipleDownloads.rightBtn')"
    @clicked="emit('hideMe')"
    @hideMe="emit('hideMe')"
    @rightButtonClicked="handleDownload">
		<div class="radio-align-wrapper">
            <selector-radio-group verticalDirection :radioParams="fileTypesRadioGroupParams" @clicked="radioClickHandler"/>
		</div>
    </modal-centered-base>
</template>

<script setup>
import ModalCenteredBase from '@/components/generic/modals/centered/Base'
import SelectorRadioGroup from '@/components/generic/selectors/radio/RadioGroup'
/* Vue */
import { ref } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'downloadFile'])

/* Props
@multipleDownloadUrls {Object} with:
    downloadPDFUrl {String} - url for PDF download button
    downloadExcelUrl {String} - url for Excel download button
*/
const props = defineProps({
    multipleDownloadUrls: Object
})

/* File Types Radio Input */
const fileTypesRadioGroupParams = ref([
    {
        id: 'pdf',
        text: t('modals.multipleDownloads.pdfLabel'),
        value: 'RadioGroup errorState&mandatory - Radio 1',
        selected: true
    }, {
        id: 'excel',
        text: t('modals.multipleDownloads.excelLabel'),
        value: ''
    }
])

const radioClickHandler = id => {
    fileTypesRadioGroupParams.value.forEach(obj => {
        obj.selected = obj.id === id
    })
}

const handleDownload = () => {
    const selectedType = fileTypesRadioGroupParams.value.find(obj => obj.selected).id
    emit('downloadFile', selectedType === 'pdf' ? props.multipleDownloadUrls.downloadPDFUrl : props.multipleDownloadUrls.downloadExcelUrl)
}
</script>

<style lang="scss" scoped>
.radio-align-wrapper {
    width: 100%;
    padding: 12px 0 0 0;
}
</style>
